import { KaizenBurst } from "../../icons/index.js";
import {
  KaizenTableParamsSchema,
  defaultKaizenTableParams,
  type KaizenTableParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { KaizenTableWidget } from "./Component.js";
import { KaizenTableEditor } from "./Editor.js";
import type { KaizenTableView } from "./types.js";

export const kaizenTableDef: SqlWidgetDef<KaizenTableParams, KaizenTableView> =
  {
    kind: "kaizenTable",
    label: "Kaizen Table",
    modes: ["dashboard"],
    singleton: true,
    defaultSize: { w: 640, h: 360 },
    defaultParams: defaultKaizenTableParams,
    Component: KaizenTableWidget,
    storage: "sql",
    schema: KaizenTableParamsSchema,
    accent: "pb-tint-5",
    icon: KaizenBurst,
    subtitle: "Filtered improvement work",
    defaultRoster: false,
    category: "single",
    layout: { col: 1, row: 1, width: 640, height: 360 },
    dashboard: {
      icon: KaizenBurst,
      defaultWidth: "wide",
      category: "Operations",
      supportsTitleOverride: true,
      EditorForm: KaizenTableEditor,
    },
  };

registerWidget(kaizenTableDef);
